module.exports = __webpack_public_path__ + "img/212-moldova.31ef8121.svg";